"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.camelize = exports._walk = exports._camelCase = void 0;
var _camelCase = function (str) { return str.replace(/[_.-](\w|$)/g, function (_, x) { return x.toUpperCase(); }); };
exports._camelCase = _camelCase;
var _walk = function (options) {
    var object = options.object, _a = options.skip, skip = _a === void 0 ? [] : _a;
    if (!object || !(object instanceof Object) || object instanceof Date || object instanceof RegExp) {
        return object;
    }
    if (Array.isArray(object)) {
        return object.map(function (item) { return (0, exports._walk)({ object: item }); });
    }
    return Object.entries(object).reduce(function (objAcc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        var skipped = skip.includes(key);
        var keyTransformed = skipped ? key : (0, exports._camelCase)(key);
        var valueTransformed = skipped ? value : (0, exports._walk)({ object: value });
        return __assign(__assign({}, objAcc), (_b = {}, _b[keyTransformed] = valueTransformed, _b));
    }, {});
};
exports._walk = _walk;
var camelize = function (object, options) {
    if (options === void 0) { options = {}; }
    if (object instanceof String) {
        return (0, exports._camelCase)(object);
    }
    var skip = options.skip;
    return (0, exports._walk)({ object: object, skip: skip });
};
exports.camelize = camelize;
//# sourceMappingURL=camelize.js.map